import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';

const ENCRYPTION_KEY =
  process.env.REACT_APP_CFG_PAY_03;

export const encryptCheckoutParams = (
  params: Record<string, unknown>,
): string => {
  const jsonString = JSON.stringify(params);
  const encrypted = AES.encrypt(jsonString, ENCRYPTION_KEY).toString();
  return encodeURIComponent(encrypted);
};

export const decryptCheckoutParams = (
  encrypted: string,
): Record<string, unknown> | null => {
  try {
    const decoded = decodeURIComponent(encrypted);
    const bytes = AES.decrypt(decoded, ENCRYPTION_KEY);
    const decryptedString = bytes.toString(Utf8);
    return JSON.parse(decryptedString);
  } catch {
    return null;
  }
};